const FiterIconAccount = () => {
    return (<>
       <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.67 5.21864C11.67 6.31611 9.28144 7.20579 6.335 7.20579C3.38856 7.20579 1 6.31611 1 5.21864M11.67 5.21864C11.67 7.72049 10.2908 9.86239 8.33563 10.7467V12.3485C8.33563 12.8503 8.0502 13.309 7.59835 13.5334L6.2646 14.1958C5.37778 14.6362 4.33438 13.9957 4.33438 13.0109V10.7467C2.37921 9.86239 1 7.72049 1 5.21864M11.67 5.21864C11.67 4.5911 10.889 4.03151 9.66938 3.66733M1 5.21864C1 4.5911 1.78096 4.03151 3.00063 3.66733M7.66875 3.00046V4.33421M5.00125 4.33421V5.00108M5.00125 0.999832V2.33358" stroke="#1062D0" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

    </>);
}

export default FiterIconAccount;